# 详情页操作记录

window.tower ||= {}

$(document).on 'click', '.comments.streams .link-fold-events', (e) ->
  $target = $(@)
  $event = $target.closest('.event')

  $target.parent().remove()
  $event.prevUntil('*:not(.event)').show()


tower.foldEvents = ->
  $streams = $('.comments.streams')

  $streams.find('.event:visible').filter ->
    return !$(@).prev('.event:visible').length
  .each ->
    $events = $(@).nextUntil('*:not(.event)')
    return  if $events.length < 4
    $lastEvent = $events.last()

    $('<span>（<a href="javascript:;" class="link-fold-events">查看更多动态</a>）</span>')
      .appendTo $lastEvent.find('.event-head')
    $events.hide()
    $lastEvent.show()
